export enum ExportKind {
  HTML = 'html',
  Markdown = 'md',
  Text = 'text',
  CSV = 'csv',
  RichText = 'rich-text',
}
